import {
  Assignment,
  Block,
  Build,
  Error,
  Favorite,
  Notifications,
  NotificationsNone,
  Warning,
  Autorenew,
  Add,
  Close,
} from "@material-ui/icons";
import {
  Avatar,
  Badge,
  Button,
  CardHeader,
  Dialog,
  DialogActions,
  Fab,
  Grid,
  IconButton,
  Tooltip,
  useMediaQuery,
  useTheme,
  withStyles,
  CssBaseline,
} from "@material-ui/core";
import {
  red,
  yellow,
  green,
  blue,
  purple,
  grey,
} from "@material-ui/core/colors";
const MarkerTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    width: 300,
    fontSize: theme.typography.pxToRem(12),
    padding: 0,
  },
  arrow: {
    color: "#f5f5f9",
  },
}))(Tooltip);
const MarkerMaps = ({ element, bridge }) => {
  var status = ["", "", null];
  if (bridge.isUsable) {
    switch (bridge.status) {
      case 1:
        status = [red["500"], "In Danger", <Error />];
        break;
      case 2:
        status = [yellow["800"], "Caution", <Warning />];
        break;
      case 3:
        status = [green["500"], "Healthy", <Favorite />];
        break;
      case 4:
        status = [blue["700"], "Under Maintenance", <Build />];
        break;
      case 5:
        status = [purple["400"], "Under Inspection", <Assignment />];
        break;
      default:
        status = ["", "", null];
        break;
    }
  } else {
    status = [grey["900"], "Unusable", <Block />];
  }

  const translate = (data) => {
    let lastTrigered = "-";
    if (data.lastTrigered !== 0) {
      //   console.log("SINI", data.lastTrigered);
      const numEpoch = Number.parseInt(data.lastTrigered);
      const date = new Date(numEpoch);
      const splitDate = date.toString().split(" ");
      const dateRemovedGMT = `${splitDate[0]}, ${splitDate[2]} ${splitDate[1]} ${splitDate[3]} - ${splitDate[4]}`;
      lastTrigered = dateRemovedGMT;
      //   console.log("DATE TRIGGERED", lastTrigered);
    }
    return { lastTrigered };
  };

  return (
    <MarkerTooltip
      arrow
      placement={"top-start"}
      title={
        <div
          className="bg-white rounded shadow overflow-hidden"
          style={{ width: 300 }}
        >
          <div
            className="position-relative overflow-hidden"
            style={{ width: 300, height: 200 }}
          >
            <img
              className="w-100"
              src={bridge.img}
              style={{ objectFit: "cover" }}
              alt="marker"
            />
            <div className="position-absolute inset-0 d-flex align-items-center justify-content-center">
              <span
                className="text-white text-center"
                style={{
                  fontSize: 30,
                  lineHeight: "1.2",
                  fontWeight: "900",
                  textShadow: "3px 3px rgba(0,0,0,0.5)",
                }}
              >
                {bridge.name}
              </span>
            </div>
          </div>
          <div className="p-2 d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <Avatar style={{ backgroundColor: status[0] }}>
                {status[2]}
              </Avatar>
              <div className="mx-2">
                <div>{status[1]}</div>
                {bridge.lastSensorTrigered !== 0 &&
                  bridge.lastSensorTrigered !== false && (
                    <div>
                      {bridge.lastSensorTrigered &&
                        `Last trigered: ${
                          translate(bridge.lastSensorTrigered).lastTrigered
                        }`}
                    </div>
                  )}
              </div>
            </div>
            <IconButton>
              <Badge color={"error"} overlap="rectangular">
                <NotificationsNone />
              </Badge>
            </IconButton>
          </div>
        </div>
      }
    >
      {element}
    </MarkerTooltip>
  );
};

export default MarkerMaps;
